<template>
  <v-select
    v-model="val"
    dir="rtl"
    :multiple="multiple"
    label="title"
    :reduce="x => x.value"
    :options="Items"
    :clearable="clearable"
    :placeholder="placeholder"
    :loading="loading"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      موردی یافت نشد
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
            v-if="loading"
            class="m-0"
            small
            variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import vSelect from 'vue-select'

export default {
  name: 'SelectSegmentBasic',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'سگمنت پایه',
    },
    placeholder: {
      type: String,
      default: 'انتخاب سگمنت پایه',
    },
  },
  data() {
    return {
      Items: [],
      selected: null,
      val: this.value,
      loading: false,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
    val(v) {
      this.$emit('input', v)
    },
  },
  created() {
    this.get()
  },
  methods: {
    get() {
      this.loading = true
      this.$http.post(
        this.$api.segmentBasic.getall, {},
      )
        .then(res => {
          this.loading = false
          res.data.forEach(item => {
            this.Items.push({ title: item.Title, value: item.Id })
          })
        })
    },
  },
}
</script>
